import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';

const HeroSection = () => {
  const [currentStory, setCurrentStory] = useState(0);
  const [isVisible, setIsVisible] = useState(true);

  const heroStories = [
    {
      id: 1,
      title: "Swetha\'s Journey to Success",
      subtitle: "An abandoned Child to Professional Nurse",
      description: "Swetha an abandoned child left by her father and mother at the age of 3 years and then she was taken care of her grandma later on she came to IGM at the age of 6 years…",
      image: "/assets/Gallery/Grp photo 2.jpg",
      cta: "Read Her Story",
      link: "#success-stories"
    },
    {
      id: 2,
      title: "Building Dreams, One Child at a Time",
      subtitle: "40 Years of transforming lives",
      description: "Since 1975, we've provided shelter, education, and love to over 500,000 children. Every child deserves a chance to dream, and your support makes it possible.",
      image: "/assets/Gallery/iGM-3.webp",
      cta: "See Our Impact",
      link: "/projects"
    },
    {
      id: 3,
      title: "Your Compassion Creates Change",
      subtitle: "Join our mission today",
      description: "Every donation, every volunteer hour, every shared story brings us closer to a world where no child is left behind. Together, we restore broken lives.",
      image: "/assets/Gallery/_DSC3967.jpg",
      cta: "Donate Now",
      link: "/donate"
    }
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setIsVisible(false);
      setTimeout(() => {
        setCurrentStory((prev) => (prev + 1) % heroStories?.length);
        setIsVisible(true);
      }, 300);
    }, 6000);

    return () => clearInterval(interval);
  }, [heroStories?.length]);

  const goToStory = (index) => {
    if (index !== currentStory) {
      setIsVisible(false);
      setTimeout(() => {
        setCurrentStory(index);
        setIsVisible(true);
      }, 300);
    }
  };

  const currentHeroStory = heroStories?.[currentStory];

  return (
    <section className="relative min-h-[80vh] md:min-h-screen flex items-center justify-center overflow-hidden bg-gradient-to-br from-warm-foundation via-background to-sky-blue/10">

      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <div className="relative w-full h-full">
          <Image
            src={currentHeroStory?.image}
            alt={currentHeroStory?.title}
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-t lg:bg-gradient-to-r  from-black/90 md:from-black/90 via-black/70 md:via-foreground/50 to-transparent"></div>

          <div className="absolute inset-0 bg-gradient-to-t lg:bg-gradient-to-l from-black/40 via-transparent to-transparent"></div>
        </div>
      </div>
      {/* Content */}
     <div className="relative z-10 w-full max-w-7xl mx-auto px-5 sm:px-6 lg:px-8 pt-36 sm:pt-24 md:pt-28 lg:pt-0 pb-6 md:pb-0">

        <div className="grid lg:grid-cols-2 gap-8 md:gap-10 lg:gap-12 items-center min-h-[80vh]">
          {/* Text Content */}
          <div
  className={`space-y-6 md:space-y-8 transition-all duration-500 ${
    isVisible
      ? "opacity-100 translate-y-0"
      : "opacity-0 translate-y-4"
  }`}
>
            <div className="space-y-3 md:space-y-4">
             
              <h2 className="font-heading font-bold text-3xl sm:text-4xl md:text-5xl lg:text-6xl leading-tight text-white">
                {currentHeroStory?.title}
              </h2>
              
              <h2 className="font-body text-lg sm:text-xl md:text-2xl text-sky-blue font-medium">
                {currentHeroStory?.subtitle}
              </h2>
              
              <p className="font-body text-base sm:text-lg text-white/90 leading-relaxed max-w-2xl">
                {currentHeroStory?.description}
              </p>
            </div>

            {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 pt-2">
              {currentHeroStory?.link.startsWith('#') ? (
  <Button
  variant="default"
  size="lg"
  onClick={(e) => {
    e.preventDefault();

    const section = document.querySelector(currentHeroStory.link);

    if (section) {
      section.scrollIntoView({
        behavior: "smooth",
      });
    }
  }}
  className="bg-conversion-orange hover:bg-conversion-orange/90 text-white shadow-warm-hover w-full sm:w-auto"
>
  {currentHeroStory?.cta}
</Button>
) : (
  <Link to={currentHeroStory?.link}>
    <Button
      variant="default"
      size="lg"
     
      className="bg-conversion-orange hover:bg-conversion-orange/90 text-white shadow-warm-hover w-full sm:w-auto"
    >
      {currentHeroStory?.cta}
    </Button>
  </Link>
)}

              
              <Link to="/about">
                <Button
                  variant="outline"
                  size="lg"
                
                  className="border-white/30 text-white hover:bg-white/10 backdrop-blur-sm w-full sm:w-auto"
                >
                  Learn About Us
                </Button>
              </Link>
            </div>

            {/* Quick Stats */}
           <div className="grid grid-cols-3 gap-3 sm:gap-5 md:gap-6 pt-6 md:pt-8 border-t border-white/20">
              <div className="text-center">
                <div className="font-heading font-bold text-xl sm:text-2xl md:text-3xl text-white">500K+</div>
                <div className="font-body text-[11px] sm:text-xs md:text-sm text-white/80 leading-snug">Lives Transformed</div>
              </div>
              <div className="text-center">
                <div className="font-heading font-bold text-xl sm:text-2xl md:text-3xl text-white">48</div>
                <div className="font-body text-[11px] sm:text-xs md:text-sm text-white/80 leading-snug">Years of Service</div>
              </div>
              <div className="text-center">
                <div className="font-heading font-bold text-xl sm:text-2xl md:text-3xl text-white">12</div>
                <div className="font-body text-[11px] sm:text-xs md:text-sm text-white/80 leading-snug">Active Programs</div>
              </div>
            </div>
          </div>

          {/* Story Navigation */}
          <div className="hidden lg:flex flex-col justify-center space-y-4">
            {heroStories?.map((story, index) => (
              <button
                key={story?.id}
                onClick={() => goToStory(index)}
                className={`text-left p-4 rounded-xl backdrop-blur-sm border transition-all duration-300 ${
                  index === currentStory
                    ? 'bg-white/20 border-white/40 shadow-warm'
                    : 'bg-white/10 border-white/20 hover:bg-white/15 hover:border-white/30'
                }`}
              >
                <div className="flex items-center space-x-3">
                  <div className={`w-3 h-3 rounded-full transition-colors ${
                    index === currentStory ? 'bg-conversion-orange' : 'bg-white/50'
                  }`}></div>
                  <div>
                    <div className="font-medium text-white text-sm">{story?.title}</div>
                    <div className="text-white/70 text-xs">{story?.subtitle}</div>
                  </div>
                </div>
              </button>
            ))}
          </div>
        </div>

        {/* Mobile Story Indicators */}
        <div className="lg:hidden flex justify-center space-x-2 mt-6 md:mt-8">
          {heroStories?.map((_, index) => (
            <button
              key={index}
              onClick={() => goToStory(index)}
              className={`w-3 h-3 rounded-full transition-colors ${
                index === currentStory ? 'bg-conversion-orange' : 'bg-white/50'
              }`}
            />
          ))}
        </div>
      </div>
      {/* Scroll Indicator */}
      <div className="hidden md:block absolute bottom-6 left-1/2 transform -translate-x-1/2 z-10">
        <div className="flex flex-col items-center space-y-2 text-white/80">
          <span className="text-sm font-body">Discover Our Impact</span>
          <Icon name="ChevronDown" size={20} className="animate-bounce" />
        </div>
      </div>
    </section>
  );
};

export default HeroSection;